import { Component, Input } from '@angular/core';

interface SituacaoConfig {
  texto: string;
  icone: string;
  classes: string;
}

/**
 * Badge de situação de matrícula do aluno.
 * Migrado da directive AngularJS app-label-situacao-matricula para Angular/PWA.
 * Usa Tailwind + Lucide no lugar de Bootstrap + Font Awesome.
 */
@Component({
  selector: 'app-label-situacao-matricula',
  templateUrl: './label-situacao-matricula.component.html'
})
export class LabelSituacaoMatriculaComponent {

  /** Código da situação de matrícula (ex: 'CURSANDO', 'APROVADO', 'REPROVADO'). */
  @Input() situacao = '';

  get config(): SituacaoConfig {
    switch (this.situacao) {

      // --- Danger (Vermelho) ---
      case 'REPROVADO':
        return {
          texto: 'Reprovado(a)',
          icone: 'x',
          classes: 'bg-red-500 dark:bg-red-600'
        };
      case 'REPROVADO_FREQUENCIA':
        return {
          texto: 'Reprov. por frequência',
          icone: 'x-circle',
          classes: 'bg-red-500 dark:bg-red-600'
        };

      // --- Primary (Azul) ---
      case 'CURSANDO':
        return {
          texto: 'Cursando',
          icone: 'graduation-cap',
          classes: 'bg-blue-500 dark:bg-blue-600'
        };

      // --- Success (Verde) ---
      case 'APROVADO':
        return {
          texto: 'Aprovado(a)',
          icone: 'check',
          classes: 'bg-green-500 dark:bg-green-600'
        };
      case 'APROVADO_CONSELHO':
        return {
          texto: 'Apr. por conselho',
          icone: 'check-circle',
          classes: 'bg-green-500 dark:bg-green-600'
        };

      // --- Warning (Amarelo) ---
      case 'EM_EXAME':
        return {
          texto: 'Em exame',
          icone: 'clock',
          classes: 'bg-yellow-500 dark:bg-yellow-600'
        };
      case 'APROVADO_DEPENDENCIA':
        return {
          texto: 'Aprov. dependência',
          icone: 'alert-triangle',
          classes: 'bg-yellow-500 dark:bg-yellow-600'
        };

      // --- Default (Cinza/Neutro) ---
      case 'DISPENSADO':
        return {
          texto: 'Dispensado(a)',
          icone: 'user-x',
          classes: 'bg-gray-500 dark:bg-gray-600'
        };
      case 'DISPENSADO_PARCIAL':
        return {
          texto: 'Disp. parcial',
          icone: 'user-x',
          classes: 'bg-gray-500 dark:bg-gray-600'
        };
      case 'REMANEJADO':
        return {
          texto: 'Remanejado(a)',
          icone: 'arrow-left-right',
          classes: 'bg-gray-500 dark:bg-gray-600'
        };
      case 'DEIXOU_FREQUENTAR':
        return {
          texto: 'Deixou frequentar',
          icone: 'log-out',
          classes: 'bg-gray-500 dark:bg-gray-600'
        };
      case 'TRANSFERIDO':
        return {
          texto: 'Transferido(a)',
          icone: 'plane',
          classes: 'bg-gray-500 dark:bg-gray-600'
        };
      case 'FALECIDO':
        return {
          texto: 'Falecido(a)',
          icone: 'minus',
          classes: 'bg-gray-500 dark:bg-gray-600'
        };
      case 'CANCELAMENTO':
        return {
          texto: 'Cancelado(a)',
          icone: 'trash-2',
          classes: 'bg-gray-500 dark:bg-gray-600'
        };
      case 'MATRICULADO':
        return {
          texto: 'Matriculado(a)',
          icone: 'file-text',
          classes: 'bg-gray-500 dark:bg-gray-600'
        };
      case 'RECLASSIFICADO_ACELERACAO':
        return {
          texto: 'Acelerado(a)',
          icone: 'fast-forward',
          classes: 'bg-gray-500 dark:bg-gray-600'
        };
      case 'RECLASSIFICADO_AVANCO':
        return {
          texto: 'Avançado(a)',
          icone: 'chevrons-up',
          classes: 'bg-gray-500 dark:bg-gray-600'
        };
      case 'EM_ANDAMENTO':
        return {
          texto: 'Em andamento',
          icone: 'loader-2',
          classes: 'bg-gray-500 dark:bg-gray-600'
        };

      default:
        return {
          texto: this.situacao || 'Indefinida',
          icone: 'help-circle',
          classes: 'bg-gray-400 dark:bg-gray-500'
        };
    }
  }
}
